import { PlatformDependent } from '@/components/PlatformDependent'

import { TournamentViewDDE } from './TournamentView.dde'

const TournamentView = () => (
  <>
    <PlatformDependent dde>
      <TournamentViewDDE />
    </PlatformDependent>
  </>
)

export default TournamentView
